﻿export default function () {
	document.addEventListener('DOMContentLoaded', function () {
		const notificationBar = document.querySelector('.notification-bar');
		const root = document.querySelector(':root');
		if (notificationBar) {
			setNotificationBarHeight();
			window.addEventListener('resize', setNotificationBarHeight);
		}

		function setNotificationBarHeight(){
			root.style.setProperty('--notification-bar-height', `${notificationBar.offsetHeight}px`);
		}
	});
}